import createSpacing from '@material-ui/core/styles/createSpacing';

const SPACING_UNIT = 8;

export default createSpacing(SPACING_UNIT);
